module.exports = __webpack_public_path__ + "static/city_icon_116-c9e4670e10f8913b4e3d679efdd3dcf1.png";